import { useState } from 'react';
import { FormInstance } from 'antd';
import { uniqueId } from 'lodash';
import { useIntl } from 'react-intl';
import { transformAdditionalData, validatePaFail } from './common';

const useBshHcAddableSection = (form: FormInstance<any>) => {
  const { formatMessage } = useIntl();
  const [addableArr, setAddableArr] = useState<
    { key: string; selectedSelf: boolean }[]
  >([{ key: uniqueId(), selectedSelf: true }]);

  const add = () => {
    setAddableArr((prev) => {
      return [...prev, { key: uniqueId(), selectedSelf: false }];
    });
  };

  const remove = (key: string) => {
    setAddableArr((prev) => {
      return prev.filter((v) => v.key !== key);
    });
  };

  const toAdditionalInsuredStep = () => {
    // 找到'self'项的key，更新值
    addableArr.forEach((item) => {
      if (item.selectedSelf) {
        const key = item?.key;
        key && copySelfValue(key);
      }
    });
  };

  const updateSelectedSelf = (key: string, isSelectedSelf: boolean) => {
    setAddableArr((prev) => {
      const newArr = [...prev];
      newArr.forEach((item) => {
        if (item.key === key) {
          item.selectedSelf = isSelectedSelf;
        }
      });
      return newArr;
    });
  };

  const copySelfValue = (key: string) => {
    const policyHolderValues = form.getFieldValue('applicant');
    Object.keys(policyHolderValues).forEach((itemKey) => {
      form.setFields([
        {
          name: ['additional_insured', `${itemKey}_${key}`],
          value: policyHolderValues[itemKey],
        },
      ]);
    });
  };

  const clearNotSelfFields = (key: string) => {
    const policyHolderValues = form.getFieldValue('applicant');
    Object.keys(policyHolderValues).forEach((itemKey) => {
      form.setFields([
        {
          name: ['additional_insured', `${itemKey}_${key}`],
          value: undefined,
        },
      ]);
    });
  };

  const validationInsured = (v: any) => {
    const insuredObj = { ...v['additional_insured'] };
    const reqArr = transformAdditionalData(insuredObj);
    if (validatePaFail(reqArr, form.getFieldValue('policy'), formatMessage)) {
      return [];
    }
  };

  return {
    addableArr,
    updateSelectedSelf,
    copySelfValue,
    toAdditionalInsuredStep,
    clearNotSelfFields,
    add,
    remove,
    validationInsured,
  };
};

export default useBshHcAddableSection;
